/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
// Copyright 2021 channysok
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// Scripts for firebase and firebase messaging

import firebase from 'firebase/app';
import 'firebase/messaging';

var firebaseConfig = {
  apiKey: "AIzaSyCwpBPWEL4-W8DDBgvM_7JRd5G3ZKdfy5w",
  authDomain: "hub2b-d9055.firebaseapp.com",
  projectId: "hub2b-d9055",
  storageBucket: "hub2b-d9055.appspot.com",
  messagingSenderId: "359243680650",
  appId: "1:359243680650:web:2773e228194c1542be1673",
  measurementId: "G-NPRZ8MVCR1"
};

firebase.initializeApp(firebaseConfig);
// const messaging = firebase.messaging();
const messaging = firebase.messaging.isSupported() ? firebase.messaging() : null
const onMessageListener = () =>
  new Promise((resolve) => {
    messaging.onMessage((payload) => {
      resolve(payload);
    });
});

const getToken = (setTokenFound) => {
  if(messaging == null) return null;
  return messaging.getToken({vapidKey: 'BKIecNKr_MqTK7WKnd-XwhOwbYtExD1OUGEX-HMSNs5l40v9isIEnE1qeODAPUndCGp9GNCAij4tcblsihVqUgs'}).then((currentToken) => {
    if (currentToken) {
      //console.log('current token for client: ', currentToken);
      setTokenFound(true);
      // Track the token -> client mapping, by sending to backend server
      // show on the UI that permission is secured
    } else {
      setTokenFound(false);
      // shows on the UI that permission is required
    }
  }).catch((err) => {
    // catch error while creating client token
  });
}

export {onMessageListener, getToken}
